import styles from './styles/_nextSesions.module.scss';
import { useHistory } from 'react-router-dom';
import { formatDate } from 'src/utils/dates';
import { Event } from '@material-ui/icons';

const Detail = ({ stylesDivider, idSesion, organ, sesion, date, hour }) => {
	const history = useHistory();
	const onDetail = (idSesion) =>
		history.push(`/sesiones/consultar-sesiones/sesion/${idSesion}`);

	return (
		<div className={styles.dayContainer}>
			<div
				className={'btn btn-clean'}
				style={{ width: '100%' }}
				onClick={() => onDetail(idSesion)}
			>
				<div className={styles.dayLabels}>
					<strong>{organ} </strong>
					<strong>{sesion}</strong>
					<div
						className={'btn btn-primary btn-lg active'}
						style={{ backgroundColor: '#2569a8' }}
					>
						<Event />
						<span className="ml-lg-3">
							<span> {formatDate('EEEE PPP, HH:mm', new Date(date))}</span>
						</span>
					</div>
				</div>
			</div>
			<hr className={styles.dayDivider} style={{ ...stylesDivider }} />
		</div>
	);
};

export default Detail;
